import { z } from "zod"

const DESCRIPTION_MAX = 2000
const DEFINITION_MAX = 32_000

export const characterSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters").max(30),
  description: z.string().max(DESCRIPTION_MAX, `Description must be at most ${DESCRIPTION_MAX} characters`).optional().default(""),
  gender: z.enum(["female", "male", "trans"]),
  age: z.number().min(18).max(99),
  ethnicity: z.string().min(1, "Please select an ethnicity"),
  hairStyle: z.string().min(1, "Please select a hairstyle"),
  hairColor: z.string().min(1, "Please select a hair color"),
  eyeColor: z.string().min(1, "Please select an eye color"),
  bodyType: z.string().min(1, "Please select a body type"),
  breastSize: z.string().optional(),
  buttSize: z.string().optional(),
  personality: z.array(z.string()).min(1, "Select at least one personality trait").max(5),
  backstory: z.string().max(DEFINITION_MAX, `Definition must be at most ${DEFINITION_MAX} characters`).optional().default(""),
  interests: z.array(z.string()).optional().default([]),
  style: z.enum(["realistic", "anime"]),
  communicationStyle: z.string().optional(),
  dominanceLevel: z.number().min(0).max(100).optional(),
  // New fields
  skinTone: z.string().max(50).optional(),
  occupation: z.string().max(100).optional(),
  relationshipType: z.string().max(50).optional(),
  hobby: z.string().max(100).optional(),
  fetish: z.string().max(100).optional(),
  voiceId: z.string().min(1, "Please select a voice"),
  greeting: z.string().max(500).optional(),
  scenario: z.string().max(500).optional(),
  customPhysicalDetails: z.string().max(1000).optional(),
  additionalPersonalityDetails: z.string().max(1000).optional(),
  extraDetails: z.string().max(1000).optional(),
}).refine(
  (data) => !["female", "trans"].includes(data.gender) || (!!data.breastSize && !!data.buttSize),
  { message: "Breast size and butt size are required for female and trans characters", path: ["breastSize"] }
)
